import { createOutlineScrollTracker } from './outlineScrollTracker';

export const setUpOutline = () => {
  const progressLine = document.querySelector(
    '.js-outline-progress-line',
  ) as HTMLElement;
  const outlineElements = document.querySelectorAll(
    '[class*="js-outline-element-"]',
  ) as NodeListOf<HTMLElement>;
  const outlineToggle = document.querySelector(
    '.js-outline-toggle',
  ) as HTMLElement;
  const outlineContainer = document.querySelector(
    '.js-outline-container',
  ) as HTMLElement;

  if (
    !progressLine ||
    !outlineElements.length ||
    !outlineToggle ||
    !outlineContainer
  )
    return;

  // Initialize scroll tracking using shared utility
  createOutlineScrollTracker({
    elements: outlineElements,
    progressLine,
    dotSelector: '.outline--progress-dot',
    progressCssVar: '--progress-percentage',
  });

  const handleOutlineToggle = () => {
    const isExpanded = outlineToggle.getAttribute('aria-expanded') === 'true';
    if (isExpanded) {
      outlineToggle.setAttribute('aria-expanded', 'false');
      outlineToggle.setAttribute('aria-label', 'Expand outline');
      outlineContainer.classList.remove('expanded');
      outlineToggle.classList.remove('expanded');
      progressLine.classList.remove('expanded');
    } else {
      outlineToggle.setAttribute('aria-expanded', 'true');
      outlineToggle.setAttribute('aria-label', 'Collapse outline');
      outlineContainer.classList.add('expanded');
      outlineToggle.classList.add('expanded');
      progressLine.classList.add('expanded');
    }
  };

  const collapseOutline = () => {
    if (outlineToggle.getAttribute('aria-expanded') === 'true') {
      handleOutlineToggle();
    }
  };

  // Add click handlers to all outline element links
  outlineElements.forEach((element) => {
    const link = element.querySelector(
      '.outline--element-label',
    ) as HTMLElement;
    if (link) {
      link.addEventListener('click', () => {
        collapseOutline();
      });
    }
  });

  outlineToggle.addEventListener('click', handleOutlineToggle);
};
